// src/App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import LoriTemplate from './templates/LoriTemplate';
import './styles/global.css';
import Responses from './pages/Responses';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import VerifyCode from './pages/VerifyCode';
import ResetPassword from './pages/ResetPassword';
import OpenProjects from './pages/OpenProjects';
import { getSubdomain } from './utils/routingUtils';

function AuthGuard({ children }) {
  const token = sessionStorage.getItem('token');
  const location = useLocation();
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

function SubdomainLoriTemplate({ editorViewEnabled = false }) {
  const subdomain = getSubdomain();
  console.log(subdomain);
  
  if (subdomain) {
    return <LoriTemplate editorViewEnabled={editorViewEnabled} subdomainId={subdomain} />;
  }
  
  return <Navigate to="/" replace />;
}

function App() {
  const [subdomain, setSubdomain] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const currentSubdomain = getSubdomain();
    setSubdomain(currentSubdomain);
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <div>
        <Routes>
          {subdomain ? (
            <>
              <Route path="/" element={<SubdomainLoriTemplate editorViewEnabled={false} /> } />
              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/verify-code" element={<VerifyCode />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/invites" element={<OpenProjects />} />
              <Route path="/invites/:id" element={<LoriTemplate editorViewEnabled={false} />} />
              <Route path="/invites/:id/editor" element={
                <AuthGuard>
                  <LoriTemplate editorViewEnabled={true} />
                </AuthGuard>
              } />
              <Route path="/invites/:id/responses" element={
                <AuthGuard>
                  <Responses />
                </AuthGuard>
              } />
              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          )}
        </Routes>
      </div>
    </Router>
  );
}

export default App;